import ProMarketingCTAs from "./ProMarketingCTAs"

describe("Rendering the ProMarketingCTAs component", () => {
  // Examples of rendering a component to the screen and making simple
  // document based assertions
  it('renders', () => {
    const { getByText } = render(<ProMarketingCTAs />)

    expect(getByText("Org Chart Library")).toBeInTheDocument();
    expect(getByText("The Information Pro Weekly Wrap")).toBeInTheDocument();
  });
});
